import { render, staticRenderFns } from "./TranslationsFrontend.vue?vue&type=template&id=35dac598&"
import script from "./TranslationsFrontend.vue?vue&type=script&lang=js&"
export * from "./TranslationsFrontend.vue?vue&type=script&lang=js&"
import style0 from "./TranslationsFrontend.vue?vue&type=style&index=0&id=35dac598&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports